export enum UIACTION {
	APPROVAL_GROUP_ACTION = "/UI/ACTION/approval-group-action",
	CHECK_GRUPO_AIRE_WORK_TASK = "/UI/ACTION/check-grupo-aire-work-task",
	CHECK_WORK_TASK = "/UI/ACTION/check-work-task",
	CUSTOMER_ADD_NEW_EXTRAS_ACTION = "/UI/ACTION/customer-add-new-extras-action",
	CUSTOMER_AGGRUPATION_ACTION = "/UI/ACTION/aggrupation-action",
	CUSTOMER_CREATE_CHARGE_OR_CREDIT_ACTION = "/UI/ACTION/customer-create-charge-or-credit",
	CUSTOMER_EDIT_BILLING_CYCLE_ACTION = "/UI/ACTION/customer-edit-billing-cycle",
	CUSTOMER_EDIT_BILLING_DELIVERY_CONTACT_ACTION = "/UI/ACTION/customer-edit-billing-delivery-contact",
	CUSTOMER_EDIT_BILLING_IDENTIFICATION_PAYMENT_METHOD_ACTION = "/UI/ACTION/customer-edit-billing-identification-payment-method",
	CUSTOMER_EDIT_BILLING_INVOICE_DELIVERY_INTERVAL_ACTION = "/UI/ACTION/customer-edit-billing-invoice-delivery-interval",
	CUSTOMER_EDIT_BILLING_INVOICE_DELIVERY_METHOD_ACTION = "/UI/ACTION/customer-edit-billing-invoice-delivery-method",
	CUSTOMER_EDIT_BILLING_NEXT_INVOICE_ACTION = "/UI/ACTION/customer-edit-billing-next-invoice",
	CUSTOMER_EDIT_BILLING_REFERENCES_ACTION = "/UI/ACTION/customer-edit-billing-references",
	CUSTOMER_EDIT_DOCUMENT_ACTION = "/UI/ACTION/customer-edit-document",
	CUSTOMER_HANDOVER_ACTIONS = "/UI/ACTION/handover-actions",
	CUSTOMER_PRODUCT_CANCEL_CHANGE_OF_ADDRESS_ACTION = "/UI/ACTION/customer-product-cancel-change-of-address-action",
	CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_ACTION = "/UI/ACTION/customer-product-change-of-address-action",
	CUSTOMER_PRODUCT_CONTINUE_CHANGE_OF_ADDRESS_ACTION = "/UI/ACTION/customer-product-continue-change-of-address-action",
	CUSTOMER_PRODUCT_CONFIG_ACTION = "/UI/ACTION/customer-product-config-action",
	CUSTOMER_PRODUCT_MODIFICATION_ACTION = "/UI/ACTION/customer-product-modification-action",
	CUSTOMER_PRODUCT_SEE_DETAILS_ACTION = "/UI/ACTION/customer-product-see-details-action",
	CUSTOMER_PRODUCT_SEE_USAGE_ACTION = "/UI/ACTION/customer-product-see-usage-action",
	CUSTOMER_PRODUCT_SIM_CHANGE_ACTION = "/UI/ACTION/customer-product-sim-change-action",
	CUSTOMER_PRODUCT_STOP_CHANGE_OF_ADDRESS_ACTION = "/UI/ACTION/customer-product-stop-change-of-address-action",
	CUSTOMER_PRODUCT_TERMINATE_ACTION = "/UI/ACTION/customer-product-terminate-action",
	CUSTOMER_PRODUCT_TRANSITION_ACTION = "/UI/ACTION/customer-product-transition-action",
	CUSTOMER_PRODUCT_TRANSITION_ONLY_MOBILES_ACTION = "/UI/ACTION/customer-product-transition-only-mobiles-action",
	CUSTOMER_PRODUCT_TRANSITION_SHARED_MOBILES_ACTION = "/UI/ACTION/customer-product-transition-shared-mobiles-action",
	CREATE_GENERIC_LEAD = "/UI/ACTION/create-generic-lead",
	DOWNLOAD_LEAD_HISTORY = "/UI/ACTION/download-lead-history",
	SEND_CONTRACT_DIGITEL = "/UI/ACTION/send-contract-digitel",
	SKIP_SIGNATURE_ACTION = "/UI/ACTION/skip-signature"
}

export enum Role {
	ADMIN = "admin",
	MANAGER = "manager",
	OPERATOR = "operator"
}

export enum StorageConfiguration {
	B2B_SEGMENTS = "B2B_SEGMENTS",
	BILLING_CYCLES = "BILLING_CYCLES",
	BLACKLISTED_APARTMENTS_CHANNELS = "BLACKLISTED_APARTMENTS_CHANNELS",
	BLACKLISTED_APARTMENTS_OPERATORS = "BLACKLISTED_APARTMENTS_OPERATORS",
	CONTRACT_SPECIFIC_NETWORKS = "CONTRACT_SPECIFIC_NETWORKS",
	CREDIT_VALIDATION_CHANNELS = "CREDIT_VALIDATION_CHANNELS",
	CUSTOMER_PRODUCT_ACTION_OMIT_DEBT_VALIDATION_CHANNELS = "CUSTOMER_PRODUCT_ACTION_OMIT_DEBT_VALIDATION_CHANNELS",
	DEPENDENCY_GROUPS = "DEPENDENCY_GROUPS",
	DIGITEL_SIGN_FLOWS_CONFIG = "DIGITEL_SIGN_FLOWS_CONFIG",
	DIGITEL_CONTRACT_CHANNELS_B2B = "DIGITEL_CONTRACT_CHANNELS_B2B",
	DIGITEL_CONTRACT_CHANNELS_B2C = "DIGITEL_CONTRACT_CHANNELS_B2C",
	DIGITEL_DEFAULT_USERS_PHONE = "DIGITEL_DEFAULT_USERS_PHONE",
	FORBIDDEN_SALE_PROCESS_STATUSES = "FORBIDDEN_SALE_PROCESS_STATUSES",
	IBAN_SUPPORTED_COUNTRIES = "IBAN_SUPPORTED_COUNTRIES",
	IBAN_VALIDATION_CHANNELS = "IBAN_VALIDATION_CHANNELS",
	LOCKED_SALE_PROCESS_STATUSES = "LOCKED_SALE_PROCESS_STATUSES",
	PRODUCTS_MANDATORY_DOCUMENTS = "PRODUCTS_MANDATORY_DOCUMENTS",
	PROMOTION_GROUPS = "PROMOTION_GROUPS",
	PROVINCE_PREFIXES = "PROVINCE_PREFIXES",
	REFERENCE_DATES = "REFERENCE_DATES",
	RETAIL_EXCLUSIVITY_RULES = "RETAIL_EXCLUSIVITY_RULES",
	SALES_AREAS = "SALES_AREAS",
	SEND_BSS_SERVICIABLE_STATUSES = "SEND_BSS_SERVICIABLE_STATUSES",
	SUPER_MANAGERS = "SUPER_MANAGERS"
}

export enum DropdownTypes {
	ADDRESS_STATUS_TYPES = "ADDRESS_STATUS_TYPES",
	APPROVAL_VALIDATION_TYPES = "APPROVAL_VALIDATION_TYPES",
	BILL_STATE_TYPES = "BILL_STATE_TYPES",
	BILL_TYPE_TYPES = "BILL_TYPE_TYPES",
	BUNDLE_TYPE_CONFIGURATION_VALUE_TYPES = "BUNDLE_TYPE_CONFIGURATION_VALUE_TYPES",
	BUSINESS_COMPANY_IDENTIFICATION_TYPES = "BUSINESS_COMPANY_IDENTIFICATION_TYPES",
	BUSINESS_INDIVIDUAL_IDENTIFICATION_TYPES = "BUSINESS_INDIVIDUAL_IDENTIFICATION_TYPES",
	BUSINESS_TYPES = "BUSINESS_TYPES",
	CHARACTERISTIC_GROUP_TYPES = "CHARACTERISTIC_GROUP_TYPES",
	CONTACT_MEDIUM_TYPES = "CONTACT_MEDIUM_TYPES",
	COUNTRY_STATE_TYPES = "COUNTRY_STATE_TYPES",
	COUNTRY_TYPES = "COUNTRY_TYPES",
	CUSTOMER_ACCOUNT_DOCUMENT_TYPES = "CUSTOMER_ACCOUNT_DOCUMENT_TYPES",
	CUSTOMER_AGGRUPATION_STATUS_TYPES = "CUSTOMER_AGGRUPATION_STATUS_TYPES",
	CUSTOMER_AGGRUPATION_READY_PRODUCT_PROCESS_TYPES = "CUSTOMER_AGGRUPATION_READY_PRODUCT_PROCESS_TYPES",
	CUSTOMER_ASSOCIATION = "CUSTOMER_ASSOCIATION",
	CUSTOMER_STATE_TYPES = "CUSTOMER_STATE_TYPES",
	CUSTOMER_TYPES = "CUSTOMER_TYPES",
	DIGITEL_CIRCUIT_TYPES = "DIGITEL_CIRCUIT_TYPES",
	ELECTRONIC_INVOICE_TYPES = "ELECTRONIC_INVOICE_TYPES",
	IBAN_COUNTRY_TYPES = "IBAN_COUNTRY_TYPES",
	IBAN_VALIDATION_IDENTIFICATION_TYPES = "IBAN_VALIDATION_IDENTIFICATION_TYPES",
	INVENTORY_PRODUCT_STATE_TYPES = "INVENTORY_PRODUCT_STATE_TYPES",
	INVOICE_DELIVERY_INTERVAL_TYPES = "INVOICE_DELIVERY_INTERVAL_TYPES",
	INVOICE_DELIVERY_METHOD_TYPES = "INVOICE_DELIVERY_METHOD_TYPES",
	JIRA_TICKET_FILTER_STATUS_TYPES = "JIRA_TICKET_FILTER_STATUS_TYPES",
	LANGUAGES = "LANGUAGES",
	OPERATOR_PREFERRED_CONTACT_TIME_TYPES = "OPERATOR_PREFERRED_CONTACT_TIME_TYPES",
	OPERATOR_TITLE_TYPES = "OPERATOR_TITLE_TYPES",
	ORDER_STATE_TYPES = "ORDER_STATE_TYPES",
	PAYMENT_METHOD_TYPES = "PAYMENT_METHOD_TYPES",
	PORTIN_OPERATOR_TYPES = "PORTIN_OPERATOR_TYPES",
	PRODUCT_ACTION_STATUS_TYPES = "PRODUCT_ACTION_STATUS_TYPES",
	PRODUCT_CHARACTERISTIC_ACTION_TYPES = "PRODUCT_CHARACTERISTIC_ACTION_TYPES",
	PRODUCT_TERMINATION_REASON_TYPES = "PRODUCT_TERMINATION_REASON_TYPES",
	PRODUCT_TRANSITION_COMBINATION_MOBILE_TYPES = "PRODUCT_TRANSITION_COMBINATION_MOBILE_TYPES",
	RELATED_PARTY_TYPES = "RELATED_PARTY_TYPES",
	RESIDENTIAL_IDENTIFICATION_TYPES = "RESIDENTIAL_IDENTIFICATION_TYPES",
	RETAIL_EXCLUSIVITY_RULES_MONTHS = "RETAIL_EXCLUSIVITY_RULES_MONTHS",
	ROLES = "ROLES",
	SALE_PROCESS_STATUS_TYPES = "SALE_PROCESS_STATUS_TYPES",
	SALES_PERSON_TYPES = "SALES_PERSON_TYPES",
	STREET_TYPES = "STREET_TYPES",
	SUMA_CALL_FORWARDING_WHEN_NO_ANSWER_TIMEOUT_TYPES = "SUMA_CALL_FORWARDING_WHEN_NO_ANSWER_TIMEOUT_TYPES",
	T4W_FORM_ID_TYPES = "T4W_FORM_ID_TYPES",
	TASK_CATEGORY_TYPES = "TASK_CATEGORY_TYPES",
	TASK_STATE_TYPES = "TASK_STATE_TYPES",
	TAX_EXEMPTION_BREAKDOWN_TYPES = "TAX_EXEMPTION_BREAKDOWN_TYPES",
	TAX_EXEMPTION_INVOICE_BREAKDOWN_TYPES = "TAX_EXEMPTION_INVOICE_BREAKDOWN_TYPES",
	TAX_EXEMPTION_REASON_TYPES = "TAX_EXEMPTION_REASON_TYPES",
	TENANTS = "TENANTS",
	TRANSITION_DOWNGRADE_REASON_TYPES = "TRANSITION_DOWNGRADE_REASON_TYPES"
}

export enum ProductInstanceAction {
	ADD = "ADD",
	NO_CHANGE = "NO_CHANGE",
	DELETE = "DELETE",
	SWAP = "SWAP",
	MAKE_PRINCIPAL = "MAKE_PRINCIPAL"
}

export enum BillingPaymentMethodType {
	BANK_TRANSFER = "BANK_TRANSFER",
	CARD = "CARD",
	DIRECT_DEBIT = "DIRECT_DEBIT",
	WRITE_OFF = "WRITE_OFF",
	UNKNOWN = "UNKNOWN"
}

export enum BillingDeliveryMethodType {
	ELECTRONIC_INVOICE = "ELECTRONIC_INVOICE"
}

/**
 * Default customer identification country, used when no country is specified.
 * Used for customer identification forms and for portin customer identification forms.
 */
export const APP_DEFAULT_CUSTOMER_IDENTIFICATION_COUNTRY = "ES";
